// Хранилище модуля «Спецификации и комплектация» (ТЗ 12.6): спецификация с позициями и сводом,
// проект, которому она принадлежит, активные и завершённые задания AI.
//
// Спецификация лежит здесь целиком, поэтому вкладки проекта («Ведомость поставки», «Чаты»)
// берут её идентификатор отсюда и не перечитывают позиции ради него.
//
// Фильтры, сортировка и группировка — локальное состояние страницы, здесь их нет.
// Сгенерировано Claude.

export default {
  namespaced: true,

  state: {
    specification: null,
    /** Проект, для которого прочитана спецификация: по нему её перечитывают. */
    projectId: null,
    /**
     * Задания AI, состояние которых показывает индикатор в шапке (ТЗ 6.2): активные и последнее
     * завершённое каждого типа — заданий может быть несколько одновременно (ТЗ 4.1).
     */
    jobs: [],
  },

  mutations: {
    setSpecification(state, specification) {
      state.specification = specification;
    },

    setProjectId(state, projectId) {
      state.projectId = projectId;
    },

    /** Позиция после ответа сервера: вычисляемые поля берутся из ответа (ТЗ 6.2). */
    setItem(state, item) {
      if (!state.specification) return;
      const items = state.specification.items ?? [];
      const index = items.findIndex((i) => i.id === item.id);
      if (index < 0) {
        state.specification = { ...state.specification, items: [...items, item] };
        return;
      }
      const updated = [...items];
      updated.splice(index, 1, item);
      state.specification = { ...state.specification, items: updated };
    },

    removeItem(state, id) {
      if (!state.specification) return;
      const items = (state.specification.items ?? []).filter((i) => i.id !== id);
      state.specification = { ...state.specification, items };
    },

    /**
     * Новое задание в индикатор. Завершённое задание того же типа уступает ему место: иначе
     * «Готово» прошлых запусков копились бы в шапке.
     */
    addJob(state, job) {
      const finished = (j) => !['queued', 'processing'].includes(j.status);
      const others = state.jobs.filter((j) => j.id !== job.id && !(j.type === job.type && finished(j)));
      state.jobs = [...others, job];
    },

    /** Новое состояние задания из опроса; задания, которого уже нет в индикаторе, не добавляет. */
    setJob(state, job) {
      const index = state.jobs.findIndex((j) => j.id === job.id);
      if (index < 0) return;
      const updated = [...state.jobs];
      updated.splice(index, 1, job);
      state.jobs = updated;
    },

    removeJob(state, id) {
      state.jobs = state.jobs.filter((j) => j.id !== id);
    },

    clearJobs(state) {
      state.jobs = [];
    },

    clear(state) {
      state.specification = null;
      state.projectId = null;
      state.jobs = [];
    },
  },

  getters: {
    items: (state) => state.specification?.items ?? [],
    categoryOrder: (state) => state.specification?.categoryOrder ?? [],
    /** Свод спецификации целиком — как его посчитал сервер (ТЗ 7.2, 4.1). */
    summary: (state) => state.specification?.summary?.total ?? null,
    /** Итоги по категориям из того же свода: ключ — код категории (ТЗ 7.2). */
    categorySummary: (state) => state.specification?.summary?.byCategory ?? {},
    /** Бюджет относительно порога цены и сумма с предложенными аналогами — тоже от сервера. */
    budget: (state) => state.specification?.summary?.budget ?? null,
  },
};
